import ProtectSettingsPushNotificationsTimedReminderComponent from '../timed-reminder/component';

export default class ProtectSettingsPushNotificationsSignOutReminderComponent extends ProtectSettingsPushNotificationsTimedReminderComponent {
  defaultTime = '5:00 pm';
}
